import { useCallback } from "react"
import { ConnectionHandler } from "relay-runtime"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import {
  Ch_approveAndGenerateCarePlanDocumentInput,
  chApproveAndGenerateCarePlanDocumentMutation,
  chApproveAndGenerateCarePlanDocumentMutation$data,
} from "@/modules/patients/services/ch/__generated__/chApproveAndGenerateCarePlanDocumentMutation.graphql"
import { chApproveAndGenerateCarePlanDocumentMutation as chMutation } from "@/modules/patients/services/ch/chApproveAndGenerateCarePlanDocumentMutation"
import {
  De_approveAndGenerateCarePlanDocumentInput,
  deApproveAndGenerateCarePlanDocumentMutation,
  deApproveAndGenerateCarePlanDocumentMutation$data,
} from "@/modules/patients/services/de/__generated__/deApproveAndGenerateCarePlanDocumentMutation.graphql"
import { deApproveAndGenerateCarePlanDocumentMutation as deMutation } from "@/modules/patients/services/de/deApproveAndGenerateCarePlanDocumentMutation"

const useApproveAndGenerateCarePlanDocumentMutation = () => {
  const country = useCountryParam()

  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutationWithErrorDialog<
    chApproveAndGenerateCarePlanDocumentMutation & deApproveAndGenerateCarePlanDocumentMutation
  >(mutation)

  return useCallback(
    (
      input: De_approveAndGenerateCarePlanDocumentInput & Ch_approveAndGenerateCarePlanDocumentInput,
      onCompleted?: (
        res: chApproveAndGenerateCarePlanDocumentMutation$data & deApproveAndGenerateCarePlanDocumentMutation$data,
      ) => void,
    ) =>
      new Promise((resolve) => {
        const carePlanSummaryConnectionId = ConnectionHandler.getConnectionID(
          input.progressNoteId,
          "ProgressNoteConnection_carePlanSummary",
        )

        commit({
          variables: {
            input,
            connections: [carePlanSummaryConnectionId],
          },
          onCompleted(response) {
            onCompleted?.(response)
            resolve(response)
          },
        })
      }),
    [commit],
  )
}

export { useApproveAndGenerateCarePlanDocumentMutation }
